export enum FulfillmentChannel {
  Merchant = 'Merchant',
  Marketplace = 'Marketplace',
}
